import React from 'react'
import { Modal } from '@material-ui/core'
import ConfirmCard from '../../../components/common/Card'
import Text from '../../../components/common/Text'
import Button from '../../../components/common/Button'

type Props = {
  open: boolean
  onClose: () => void
  initialValues?: { name: string; categoryName: string }
  onSubmit: () => void
}

const ConfirmModal = (props: Props) => {
  const { open, onClose, onSubmit } = props

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <ConfirmCard
        style={{
          display: 'flex',
          width: '300px',
          padding: '30px',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Text>Confirm</Text>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignSelf: 'center',
            paddingTop: '10px',
          }}
        >
          <Button
            style={{
              alignSelf: 'center',
              marginRight: '20px',
            }}
            onClick={onSubmit}
          >
            Yes
          </Button>
          <Button variant="danger" onClick={onClose}>
            No
          </Button>
        </div>
      </ConfirmCard>
    </Modal>
  )
}

export default ConfirmModal
